import { autoinject } from 'aurelia-framework';
import { PenOfferTabProps } from '../tabs';

@autoinject
export class Tab {
  data: PenOfferTabProps;

  activate(data: PenOfferTabProps) {
    this.data = data;
  }
}
